import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=00f317b4&scoped=true&"
import script from "./Persona.vue?vue&type=script&lang=js&"
export * from "./Persona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f317b4",
  null
  
)

export default component.exports